export default __webpack_public_path__ + "static/N0225-c1e5a42d4dba090aaeb47f6098853c15.png";